import script from "./TaskItemInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskItemInput.vue?vue&type=script&setup=true&lang=js"

import "./TaskItemInput.vue?vue&type=style&index=0&id=752e2dbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-752e2dbb"]])

export default __exports__